import { Injectable } from '@angular/core';
import { AbstractControlOptions, UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  PledgeRead,
  Parameters,
} from '@app/forms/subscription/definition/interface/Pledge';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        scpiSelectionType: [parameters?.scpiSelectionType || 'FREE'],
      },
      options,
    );
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
}
